import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FormatoNumberService {

  constructor() { }

  // funcion que nos permite poner las comas en los digitos
  facProImporteAsString(number: any): any {
    let importe = parseFloat(number.toString().replace(/,/g, '')); // Elimina las comas si las hubiera
    if (!isNaN(importe)) {
      return importe.toLocaleString('en-US'); // Formatear con comas
    } else {
      return '';
    }
  }

 // Función para convertir un número formateado en una cadena de texto a un número
regresarNumero(numeroLlegada: any): any {
  // Verificar que el valor de entrada es una cadena
  if (typeof numeroLlegada !== 'string') return "";

  // Eliminar las comas y convertir a número
  let numeroSinComas = parseFloat(numeroLlegada.replace(/,/g, ''));

  // Verificar que el valor convertido sea un número
  if (!isNaN(numeroSinComas)) {
    return numeroSinComas;
  }

  return numeroLlegada; // Si el valor no es un número, devolver el valor original
}

// Función para permitir solo números y un solo punto decimal y formatear el valor con comas
// Función para permitir solo números y un solo punto decimal, y formatear el valor con comas
soloNumeros(event: any) {
  let inputValue = event.target.value;

  // Eliminar todos los caracteres no numéricos y puntos
  let sanitizedValue = inputValue.replace(/[^0-9.]/g, '');

  // Verificar si hay más de un punto decimal
  let partes = sanitizedValue.split('.');
  if (partes.length > 2) {
    sanitizedValue = partes[0] + '.' + partes.slice(1).join('');
  }

  // Limitar la parte decimal a 2 dígitos
  if (partes.length > 1) {
    sanitizedValue = partes[0] + '.' + (partes[1] || '').substring(0, 2);
  }

  // Agregar comas a la parte entera
  let [entero, decimal] = sanitizedValue.split('.');
  entero = entero.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  // Volver a unir la parte entera con la decimal
  sanitizedValue = decimal ? `${entero}.${decimal}` : entero;
  
  // Actualizar el valor del campo
  event.target.value = sanitizedValue;
}

}
